// src/layout/TermsAndConditions.jsx
import React, { useState, useCallback } from "react";
import { ReactComponent as Impressum_icon } from "../assets/icons/Impressum_icon.svg";
import { ReactComponent as BFSG_icon } from "../assets/icons/BFSG_icon.svg";
import { ReactComponent as DSVGO_icon } from "../assets/icons/DSVGO_icon.svg";
import { ReactComponent as Disclaimer_icon } from "../assets/icons/Disclaimer_icon.svg";
import { ReactComponent as Cookies_icon } from "../assets/icons/Cookies_icon.svg";
import { ReactComponent as AGB_icon } from "../assets/icons/AGB_icon.svg";

const FOCUS = "#FFFFFF";

export default function TermsAndConditions({ onNavigate }) {
  // Helper: sicher nur aufrufen, wenn vorhanden
  const go = useCallback(
    (page) => {
      if (typeof onNavigate === "function") {
        onNavigate(page);
      }
    },
    [onNavigate]
  );

  return (
    <section
      style={{
        borderRadius: 12,
        background: "rgba(0, 0, 10, 0.4)",
        border: "1px solid rgba(28,46,73,.8)",
        boxShadow:
          "inset 0 -1px 3px rgba(255,255,255,.4), inset 0 3px 2px rgba(0,0,0,.5), 0 0px 1px rgba(0,0,0,.25)",
        padding: "8px 0px",
        boxSizing: "border-box",
        color: "#e6edf3",
      }}
    >
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 3 }}>
        {/* aktuell nur Impressum wirklich „angeschlossen“ */}
        <FlatBtn
          label="Impressum"
          icon={<Icon1 size={18} />}
          onClick={() => go("imprint")}
        />
        <FlatBtn
          label="Barrierefreiheit"
          icon={<Icon2 size={18} />}
          onClick={() => go("bfsg")}
        />
        <FlatBtn
          label="Datenschutz"
          icon={<Icon3 size={18} />}
          onClick={() => go("privacy")}
        />
        <FlatBtn
          label="Disclaimer"
          icon={<Icon4 size={18} />}
          onClick={() => go("disclaimer")}
        />
        <FlatBtn
          label="Cookie Policy"
          icon={<Icon5 size={18} />}
          onClick={() => go("cookies")}
        />
        <FlatBtn
          label="AGB"
          icon={<Icon6 size={18} />}
          onClick={() => go("terms")}
        />
      </div>
    </section>
  );
}

/* Flacher Button – KEINE LED */
function FlatBtn({ label, icon, onClick }) {
  const [hover, setHover] = useState(false);
  const [focus, setFocus] = useState(false);
  const [kbd, setKbd] = useState(false);

  const handleClick = useCallback(
    (e) => {
      e.preventDefault();
      onClick?.(e);
    },
    [onClick]
  );

  return (
    <button
      type="button"
      onClick={handleClick}
      title={label}
      onPointerEnter={() => setHover(true)}
      onPointerLeave={() => setHover(false)}
      onFocus={() => setFocus(true)}
      onBlur={() => setFocus(false)}
      onKeyDown={(e) => {
        const k = e.key;
        if (k === "Tab" || k === "Shift" || k.startsWith("Arrow")) setKbd(true);
      }}
      onPointerDown={() => setKbd(false)}
      style={{
        all: "unset",
        display: "inline-flex",
        alignItems: "center",
        gap: 2,
        height: 20,
        padding: "5px 10px 5px 10px",
        boxSizing: "border-box",
        background: "transparent",
        borderRadius: 5,
        color: hover ? "rgba(182,220,255,0.9)" : "rgba(182, 220, 255, 0.5)",
        fontSize: "var(--fs-12, 12px)",
        lineHeight: 1,
        cursor: "pointer",
        outline: kbd && focus ? `1px dashed ${FOCUS}` : "none",
        outlineOffset: kbd && focus ? 3 : 0,
        transition: "color 120ms ease, background 120ms ease",
        minWidth: 0,
      }}
    >
      {icon && <span style={{ display: "block", flexShrink: 0 }}>{icon}</span>}
      <span
        style={{
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
          transform: "translateY(-0.5px)",
        }}
      >
        {label}
      </span>
    </button>
  );
}

// Icons bleiben wie gehabt – Klassen kannst du in CSS auswerten, falls gewünscht
function Icon1({ size = 20, title }) {
  return (
    <Impressum_icon
      width={size}
      height={size}
      aria-hidden={!title}
      aria-label={title}
      className="fgColor"
    />
  );
}
function Icon2({ size = 20, title }) {
  return (
    <BFSG_icon
      width={size}
      height={size}
      aria-hidden={!title}
      aria-label={title}
      className="fgColor"
    />
  );
}
function Icon3({ size = 20, title }) {
  return (
    <DSVGO_icon
      width={size}
      height={size}
      aria-hidden={!title}
      aria-label={title}
      className="fgColor"
    />
  );
}
function Icon4({ size = 20, title }) {
  return (
    <Disclaimer_icon
      width={size}
      height={size}
      aria-hidden={!title}
      aria-label={title}
      className="fgColor"
    />
  );
}
function Icon5({ size = 20, title }) {
  return (
    <Cookies_icon
      width={size}
      height={size}
      aria-hidden={!title}
      aria-label={title}
      className="fgColor"
    />
  );
}
function Icon6({ size = 20, title }) {
  return (
    <AGB_icon
      width={size}
      height={size}
      aria-hidden={!title}
      aria-label={title}
      className="fgColor"
    />
  );
}
